export const CHANNEL_LABELS: Record<string, string> = {
  testchat: 'Testchat',
  demo: 'Demo',
  web: 'Web',
  web_widget: 'Chat web',
  messenger: 'Messenger',
  facebook: 'Messenger',
  instagram: 'Instagram',
  whatsapp_js: 'WhatsApp',
  whatsapp_meta: 'WhatsApp',
  telegram: 'Telegram',
  slack: 'Slack',
  sms_twilio: 'SMS',
  email: 'Email',
  teams: 'Teams',
};

export function normalizeChannel(channel: string): string {
  if (channel === 'facebook') return 'messenger';
  return channel;
}

export function channelLabel(channel: string): string {
  const ch = normalizeChannel(channel);
  return CHANNEL_LABELS[ch] ?? ch;
}
